import { nanoid } from 'nanoid'

export function createTransactionId(): string {
  return nanoid()
}
